export default __webpack_public_path__ + "static/media/N2P_1934.93a5bd58.jpg";